
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"6","y":"10","width":"28","height":"20"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M30.835 10H9.168a2.5 2.5 0 00-2.5 2.5v15a2.5 2.5 0 002.5 2.5h21.667a2.5 2.5 0 002.5-2.5v-15a2.5 2.5 0 00-2.5-2.5zM9.168 11.667h21.667c.458 0 .833.375.833.833v2.156c-1.14.964-2.77 2.292-7.844 6.318-.152.12-.33.27-.526.436-.938.793-2.297 1.94-3.297 1.923-1.005.018-2.379-1.144-3.316-1.937-.189-.16-.36-.305-.507-.422-5.073-4.026-6.703-5.354-7.843-6.318V12.5c0-.458.375-.833.833-.833zM8.335 27.5c0 .458.375.833.833.833h21.667a.836.836 0 00.833-.833V16.823c-1.188.974-3.063 2.48-6.807 5.453-.163.13-.344.283-.539.448-1.113.941-2.708 2.29-4.32 2.276-1.623.009-3.23-1.352-4.331-2.284-.193-.163-.37-.313-.53-.44-3.744-2.974-5.619-4.48-6.806-5.453V27.5z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h40v40H0z"}})])])
          )
        }
      }
    